import * as React from 'react';

interface IProps {
    className?: string;
}

export const BaseAngleBracket: React.FC<IProps> = ({ className }) => (
    <svg className={className} viewBox="0 0 8 12">
        <defs>
            <polygon
                id="a"
                points="15.41 7.41 14 6 8 12 14 18 15.41 16.59 10.83 12"
            />
        </defs>
        <g fill="none" fillRule="evenodd">
            <g transform="translate(-252 -156)">
                <g transform="translate(244 150)">
                    <polygon points="0 0 24 0 24 24 0 24" />
                    <use fill="#FFFFFF" xlinkHref="#a" />
                </g>
            </g>
        </g>
    </svg>
);

